<div class="nft-ticker d-flex align-items-center">
    <ng-select 
    class="ticker-select w-100" placeholder="Search a Collection"
    bindLabel="name" 
    [trackByFn]="trackByFn"
    [loading]="collectionLoading"
    [typeahead]="collectionInput$"
    [(ngModel)]="selectedCollection"
    (ngModelChange)="collectionChange($event)">
    <ng-option *ngFor="let collection of collection$ | async" [value]="collection">
        <ng-container *ngIf="collection?.imageUrl">
          <img class="rounded-circle mr-1" [src]="collection?.imageUrl" class="mr-75" height="32" width="32"/>
        </ng-container>
        <ng-container *ngIf="!collection?.imageUrl">
          <img class="rounded-circle mr-1" src="assets/images/pages/no-image.png" class="mr-75" height="32" width="32"/>
        </ng-container>
        {{collection?.name}}
    </ng-option>
  </ng-select>
</div>